define('app-TravelPortal/logout/settings',[],function () {
    return {
        container: ".manageMyBooking",
        logoutModal: "#logoutModal",
        countDown: "#count-down",
        closeButton: "#closeButton"
    }
});
